import {
    StyleSheet
} from "react-native";
import type {
    SidebarMeasures
} from "../../type";

const stylesheet = StyleSheet.create({
    overlay: {
        justifyContent: "flex-end",
        pointerEvents: "box-none",
        alignItems: "flex-start",
        flexDirection: "row",
        position: "absolute",
        start: 0,
        end: 0,
        top: 0
    },
    container: {
        flexDirection: "column",
        position: "relative",
        minWidth: 0
    }
});

export const useStyles = ({
    endOffset,
    isNested,
    measures,
    height,
    spaces
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
    measures: SidebarMeasures;
    endOffset: number;
    isNested: boolean;
    height: number;
}) => {
    return {
        container: isNested ? {
            marginStart: measures.square / 2 + spaces.spacingSm
        } : {},
        overlay: {
            paddingEnd: endOffset,
            height
        }
    };
};
export default stylesheet;
